import { useCallback, useMemo, useState } from "react";

export const useChatHelpers = (groupChats, currentChat, selectedChatId, typingUsers) => {
  const [currentUserId] = useState(() => {
    try {
      const authUser = JSON.parse(localStorage.getItem("authUser"));
      return authUser?.user?._id || authUser?._id || "me";
    } catch {
      return "me";
    }
  });

  const resolveMemberById = useCallback((id) => {
    if (!id) return null;
    const fromCurrent = (currentChat?.members || []).find(m => String(m?._id) === String(id));
    if (fromCurrent) return fromCurrent;

    if (currentChat?.messages && Array.isArray(currentChat.messages)) {
      for (let i = currentChat.messages.length - 1; i >= 0; i--) {
        const msg = currentChat.messages[i];
        if (msg?.sender && String(msg.sender._id) === String(id)) {
          return msg.sender;
        }
      }
    }

    for (const g of groupChats) {
      if (Array.isArray(g?.members)) {
        const found = g.members.find(m => String(m?._id) === String(id));
        if (found) return found;
      }
    }
    return null;
  }, [currentChat?.members, currentChat?.messages, groupChats]);

  const currentChatTypingUserIds = useMemo(() => {
    return typingUsers[selectedChatId || currentChat?._id || currentChat?.chatRequestId] || [];
  }, [typingUsers, selectedChatId, currentChat]);

  const currentChatTypingUsers = useMemo(() => {
    return currentChatTypingUserIds
      .filter(id => String(id) !== String(currentUserId))
      .map(userId => {
        const member = resolveMemberById(userId);
        return member || { _id: userId, firstname: "User", profileimg: null };
      });
  }, [currentChatTypingUserIds, currentUserId, resolveMemberById]);

  return {
    currentUserId,
    resolveMemberById,
    currentChatTypingUsers
  };
};

